var Context = require('./context').Context;

var PatchContext = function PatchContext(left, delta) {
  this.left = left;
  this.delta = delta;
  this.pipe = 'patch';
};

PatchContext.prototype = new Context();

exports.PatchContext = PatchContext;



/*****************
 ** WEBPACK FOOTER
 ** ./~/jsondiffpatch/src/contexts/patch.js
 ** module id = 156
 ** module chunks = 0
 **/